import React, { useState, useEffect } from "react";
import "../FormComponents/CoAuthor_M.css";
import {
  Container,
  Row,
  Col,
  Dropdown,
  Button as B_Button,
} from "react-bootstrap";
import {
  Button,
  IconButton,
  Typography,
  Modal,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { Modal as B_Modal, Form } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";
import { TextField } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import {Delete} from "@mui/icons-material";
import { toast } from "react-toastify";
import citationService from "../../../services/citationService";
import { v4 as uuidv4 } from "uuid";
import { CoAuthor_CitationCard } from "../CitationCard";
import { CopyToClipboard } from "react-copy-to-clipboard";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import Loader from "../../../utils/loader";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import { addUserLogs } from "../../../services/userLogServices";
import { checkAIRequestLimit } from "../../aiRequestLimit";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const modernStyles = {
  container: {
    padding: '20px',
    height: '100%',
    overflowY: 'auto',
  },
  headerSection: {
    marginBottom: '24px',
  },
  selectBox: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: '12px',
    border: '2px solid',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
  },
  primaryButton: {
    padding: '12px 32px',
    backgroundColor: '#667eea',
    color: '#fff',
    border: 'none',
    borderRadius: '12px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    outline: 'none',
  },
  backButton: {
    padding: '10px 20px',
    backgroundColor: 'transparent',
    color: '#667eea',
    border: '2px solid #667eea',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '16px',
  },
  searchContainer: {
    display: 'flex',
    gap: '12px',
    alignItems: 'flex-end',
    padding: '16px',
    borderRadius: '16px',
    border: '1px solid',
    marginBottom: '20px',
    flexWrap: 'wrap',
  },
  inputGroup: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    minWidth: '150px',
  },
  label: {
    fontSize: '12px',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  input: {
    padding: '10px 14px',
    borderRadius: '8px',
    border: '2px solid',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.3s ease',
  },
  citeButton: {
    padding: '10px 24px',
    backgroundColor: '#3b82f6',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    height: '44px',
    flexShrink: 0,
    alignSelf: 'flex-end',
  },
  accordion: {
    borderRadius: '12px',
    overflow: 'hidden',
    marginTop: '16px',
    border: '1px solid',
  },
  accordionHeader: {
    padding: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
  accordionBody: {
    padding: '16px',
    borderTop: '1px solid',
  },
  iconButton: {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px',
  },
  emptyStateIcon: {
    width: '80px',
    height: '80px',
    margin: '0 auto 20px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '40px',
  },
  card: {
    padding: '16px',
    borderRadius: '12px',
    border: '1px solid',
    marginBottom: '12px',
    transition: 'all 0.3s ease',
  },
  formGroup: {
    marginBottom: '16px',
  },
  formLabel: {
    display: 'block',
    fontSize: '13px',
    fontWeight: 600,
    marginBottom: '8px',
  },
  formInput: {
    width: '100%',
    padding: '10px 14px',
    borderRadius: '8px',
    border: '2px solid',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.3s ease',
    boxSizing: 'border-box',
  },
  dateInputGroup: {
    display: 'grid',
    gridTemplateColumns: '2fr 2fr 1fr',
    gap: '12px',
  },
  contributorCard: {
    padding: '16px',
    borderRadius: '12px',
    border: '1px solid',
    marginBottom: '12px',
  },
  contributorGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '12px',
  },
};

export const Coauthor_Citationcomponent = (props) => {
  let suggestionArray = [];
  const [citations, setCitations] = useState([]);
  const [composeState, setComposestate] = useState(false);
  const [createCitationState, setCreateCitationState] = useState(true);
  const [creatClassState, setCreateClassstate] = useState(false);
  const [sourceitem, setSourceitem] = useState("Webpage");
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [websiteData, setWebsiteData] = useState(null);
  const [isCopied, setIsCopied] = useState(false);
  const [checkEdit, setCheckEdit] = useState(false);
  const [citationID, setCitationID] = useState("");
  const [publicationYearError, setPublicationYearError] = useState("");
  const [accessYearError, setAccessYearError] = useState("");
  const [publicationDayError, setPublicationDayError] = useState("");
  const [accessDayError, setAccessDayError] = useState("");
  const [selectedHeading, setSelectedHeading] = useState("Webpage");
  const [loading, setLoading] = useState(false);

  const [publicationYear, setPublicationYear] = useState("");
  const [publicationMonth, setPublicationMonth] = useState("");
  const [publicationDay, setPublicationDay] = useState("");

  const [accessYear, setAccessYear] = useState("");
  const [accessMonth, setAccessMonth] = useState("");
  const [accessDay, setAccessDay] = useState("");
  const userDetails = useSelector((user) => user);
  const userID = props.trial ? props.userId : userDetails.user.currentUser._id;

  const [sourceList, setsourceList] = useState([
    {
      value: "Webpage",
      name: "Webpage",
    },
    {
      value: "Journal Article",
      name: "Journal Article",
    },
    {
      value: "Book",
      name: "Book",
    },
  ]);

  const [professionList, setProfessionList] = useState([
    {
      value: "AMA 10th edition",
      name: "AMA 10th edition",
    },
    {
      value: "American Chemical Society",
      name: "American Chemical Society",
    },
    {
      value: "APA 11th edition",
      name: "APA 11th edition",
    },
    {
      value: "APA 6th edition",
      name: "APA 6th edition",
    },
    {
      value: "APA 7th edition",
      name: "APA 7th edition",
    },
    {
      value: "Chicago author",
      name: "Chicago author",
    },
  ]);

  const [formData, setFormData] = useState({
    heading: "",
    title: "",
    description: "",
    websiteName: "",
    contributors: [],
    url: "",
    doi: "",
    journalName: "",
    edition: "",
    publisher: "",
    articleNumber: "",
    volumeNumber: "",
    issueNumber: "",
    page: "",
    libraryDatabase: "",
    ISBN: "",
    ISSN: "",
    publicationDate: {
      year: "",
      month: "",
      day: "",
    },
    accessDate: {
      year: "",
      month: "",
      day: "",
    },
    // sourceType: ''
  });

  const [contributors, setContributors] = useState([
    {
      id: uuidv4(),
      position: "",
      firstName: "",
      middleName: "",
      lastName: "",
      suffix: "",
    },
  ]);

  const [createcitation, setCreatecitation] = useState(false);

  const headings = [
    "Webpage",
    "Journal Article",
    "Book",
    "Book Chapter",
    "Video",
    "Online Dictionary Entry",
    "Online News Article",
    "Image",
    "Report",
    "Website",
  ];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem("ThemeSwitch");
      setIsDarkMode(theme === "true");
    };
    updateTheme();
    window.addEventListener("storage", updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "ThemeSwitch") {
        updateTheme();
      }
    };
    return () => {
      window.removeEventListener("storage", updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  const [citationStyle, setCitationStyle] = useState("");
  // const [homeCitationstate , sethomeCitationstate]=useState(false)
  const handleSource = (e) => {
    setSourceitem(e);
  };

  useEffect(() => {
    setSearchInput("");
    setWebsiteData(null);
  }, [sourceitem]);

  const handleCreateCitation = async () => {
    // const checkailimit = await checkAIRequestLimit(userID);
    // console.log(checkailimit, "_checkailimit");
    // if (checkailimit == false) {
    //   toast.warn("AI request limit reached.");
    //   return;
    // }
    setCreateClassstate(true);
    setCreateCitationState(false);
  };

  const handleCompose = () => {
    setCreateClassstate(false);
    setComposestate(true);
    setCheckEdit(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseAccordion = () => {
    setWebsiteData(null);
  };

  const handleCopyClick = () => {
    setIsCopied(true);
    toast.success("Text copied");
    setWebsiteData(null);
  };

  const currentYear = new Date().getFullYear();

  const calculateMaxDay = (month, year) => {
    switch (month) {
      case "January":
      case "March":
      case "May":
      case "July":
      case "August":
      case "October":
      case "December":
        return 31;
      case "April":
      case "June":
      case "September":
      case "November":
        return 30;
      case "February":
        // Check for leap year
        return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)
          ? 29
          : 28;
      default:
        return 31; // Default to 31 if month is not recognized (for safety)
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
    console.log(formData, "formdata");
  };

  const handlePublicationYearChange = (e) => {
    const inputYear = e.target.value;

    // Check if the input is not empty and is a valid 4-digit year with only numeric characters
    if (
      inputYear === "" ||
      (parseInt(inputYear, 10) > 0 &&
        /^\d{0,4}$/.test(inputYear) &&
        parseInt(inputYear, 10) <= currentYear)
    ) {
      setPublicationYearError("");
      setPublicationYear(inputYear);

      // Additional check for day validity based on the new year and month
      const inputMonth = publicationMonth;
      const inputDay = publicationDay;
      const maxDay = calculateMaxDay(inputMonth, inputYear);

      if (inputDay !== "" && (inputDay < 1 || inputDay > maxDay)) {
        setPublicationDayError("Invalid day");
      } else {
        setPublicationDayError("");
        handleInputChange("publicationDate", {
          year: inputYear,
          month: inputMonth,
          day: inputDay,
        });
      }
    } else {
      setPublicationYearError("Invalid year");
    }
  };

  const handlePublicationMonthChange = (e) => {
    const inputMonth = e.target.value;
    setPublicationMonth(inputMonth);

    // Validate the day based on the new month and year
    const inputYear = publicationYear;
    const inputDay = publicationDay;
    const maxDay = calculateMaxDay(inputMonth, inputYear);

    if (inputDay !== "" && (inputDay < 1 || inputDay > maxDay)) {
      setPublicationDayError("Invalid day");
    } else {
      setPublicationDayError("");
      handleInputChange("publicationDate", {
        year: inputYear,
        month: inputMonth,
        day: inputDay,
      });
    }
  };

  const handlePublicationDayChange = (e) => {
    const inputDay = parseInt(e.target.value, 10);
    const inputMonth = publicationMonth;
    const inputYear = publicationYear;

    let maxDay = 31; // Default maximum days

    // Update maxDay based on the month
    if (
      inputMonth === "April" ||
      inputMonth === "June" ||
      inputMonth === "September" ||
      inputMonth === "November"
    ) {
      maxDay = 30;
    } else if (inputMonth === "February") {
      // Check for leap year
      maxDay =
        inputYear % 4 === 0 && (inputYear % 100 !== 0 || inputYear % 400 === 0)
          ? 29
          : 28;
    }

    // Check if the input is not empty and within the valid range
    if (inputDay === "" || inputDay < 1 || inputDay > maxDay) {
      setPublicationDayError("Invalid day");
    } else {
      setPublicationDayError("");
      setPublicationDay(inputDay);
      handleInputChange("publicationDate", {
        year: inputYear,
        month: inputMonth,
        day: inputDay,
      });
    }
  };

  const handleAccessYearChange = (e) => {
    const inputYear = e.target.value;

    // Check if the input is not empty and is a valid 4-digit year with only numeric characters
    if (
      inputYear === "" ||
      (parseInt(inputYear, 10) > 0 &&
        /^\d{0,4}$/.test(inputYear) &&
        parseInt(inputYear, 10) <= currentYear)
    ) {
      setAccessYearError("");
      setAccessYear(inputYear);

      // Additional check for day validity based on the new year and month
      const inputMonth = accessMonth;
      const inputDay = accessDay;
      const maxDay = calculateMaxDay(inputMonth, inputYear);

      if (inputDay !== "" && (inputDay < 1 || inputDay > maxDay)) {
        setAccessDayError("Invalid day");
      } else {
        setAccessDayError("");
        handleInputChange("accessDate", {
          year: inputYear,
          month: inputMonth,
          day: inputDay,
        });
      }
    } else {
      setAccessYearError("Invalid year");
    }
  };

  const handleAccessMonthChange = (e) => {
    const inputMonth = e.target.value;
    setAccessMonth(inputMonth);

    // Validate the day based on the new month and year
    const inputYear = accessYear;
    const inputDay = accessDay;
    const maxDay = calculateMaxDay(inputMonth, inputYear);

    if (inputDay !== "" && (inputDay < 1 || inputDay > maxDay)) {
      setAccessDayError("Invalid day");
    } else {
      setAccessDayError("");
      handleInputChange("accessDate", {
        year: inputYear,
        month: inputMonth,
        day: inputDay,
      });
    }
  };

  const handleAccessDayChange = (e) => {
    const inputDay = parseInt(e.target.value, 10);
    const inputMonth = accessMonth;
    const inputYear = accessYear;

    let maxDay = 31;

    if (
      inputMonth === "April" ||
      inputMonth === "June" ||
      inputMonth === "September" ||
      inputMonth === "November"
    ) {
      maxDay = 30;
    } else if (inputMonth === "February") {
      maxDay =
        inputYear % 4 === 0 && (inputYear % 100 !== 0 || inputYear % 400 === 0)
          ? 29
          : 28;
    }

    if (inputDay === "" || inputDay < 1 || inputDay > maxDay) {
      setAccessDayError("Invalid day");
    } else {
      setAccessDayError("");
      setAccessDay(inputDay);
      handleInputChange("accessDate", {
        year: inputYear,
        month: inputMonth,
        day: inputDay,
      });
    }
  };

  // const isValidURL = (url) => {
  //   try {
  //     // Create a new URL object
  //     const parsedUrl = new URL(url);

  //     // Extract the hostname
  //     const hostname = parsedUrl.hostname;

  //     // Check if the hostname ends with a valid top-level domain
  //     const validUrlPattern = new RegExp('\\.(com|io|org|net|gov|edu|co)$', 'i');
  //     return validUrlPattern.test(hostname);
  //   } catch (e) {
  //     // If URL constructor throws an error, it's an invalid URL
  //     return false;
  //   }
  // };

  const isValidURL = (url) => {
    try {
      // If the URL doesn't start with a protocol, add 'https://'
      if (!/^https?:\/\//i.test(url)) {
        url = "https://" + url;
      }

      // Create a new URL object
      const parsedUrl = new URL(url);

      // Extract the hostname
      const hostname = parsedUrl.hostname;

      // Check if the hostname ends with a valid top-level domain
      const validUrlPattern = new RegExp(
        "\\.(com|io|org|net|gov|edu|co)$",
        "i"
      );
      return validUrlPattern.test(hostname);
    } catch (e) {
      // If URL constructor throws an error, it's an invalid URL
      return false;
    }
  };

  const validateInput = (sourceitem, searchInput) => {
    if (sourceitem === "Webpage" && !isValidURL(searchInput)) {
      toast.warning("Please enter a valid URL");
      return false;
    }

    // Add more validation checks for other tabs if needed

    return true;
  };

  const handleCiteButtonClick = async () => {
    if (!searchInput.trim()) {
      toast.warn("Search bar is empty");
      return;
    }
    if (validateInput(sourceitem, searchInput)) {
      setLoading(true);
      try {
        let response;
        let userId = userID;
        let isCoAuthor = true;
        if (sourceitem === "Webpage") {
          response = await citationService.getCheckCitationWebpage(
            searchInput,
            citationStyle,
            sourceitem,
            userId,
            isCoAuthor
          );

          if (response.status === 200) {
            setLoading(false);
            console.log("Backend Response:", response);
            let responseOutput = response?.data?.output;
            const parsedData = JSON.parse(responseOutput[0]);
            suggestionArray = parsedData.replacements?.corrections;
            console.log("changedJSon_", suggestionArray, parsedData);
            setWebsiteData(suggestionArray);
          }
        } else if (sourceitem === "Journal Article") {
          response = await citationService.getCheckCitationJournalArticle(
            searchInput,
            citationStyle,
            sourceitem,
            userId,
            isCoAuthor
          );

          if (response.status === 200) {
            setLoading(false);
            console.log("Backend Response:", response);
            let responseOutput = response?.data?.output;
            const parsedData = JSON.parse(responseOutput[0]);
            suggestionArray = parsedData.replacements?.corrections;
            console.log("changedJSon_", suggestionArray, parsedData);
            setWebsiteData(suggestionArray);
          }
        } else {
          response = await citationService.getCheckCitationBook(
            searchInput,
            citationStyle,
            sourceitem,
            userId,
            isCoAuthor
          );

          if (response.status === 200) {
            setLoading(false);
            console.log("Backend Response:", response);
            let responseOutput = response?.data?.output;
            const parsedData = JSON.parse(responseOutput[0]);
            suggestionArray = parsedData.replacements?.corrections;
            console.log("changedJSon_", suggestionArray, parsedData);
            setWebsiteData(suggestionArray);
          }
        }
      } catch (error) {
        setLoading(false);
        toast.warn("Error fetching citation details");
        console.error("Error calling backend API:", error.message);
      }

      // setWebsiteData(suggestionArray)
    }
  };

  const handleSaveCitations2 = async () => {
    // Handle save logic here
    const email = sessionStorage.getItem("currentUserEmail");
    try {
      const response = await citationService.getAddCitation2(
        websiteData[0],
        email
      );
      console.log("Backend Response:", response);
      if (response.status == 200) {
        toast.success("Citation saved successfully");
        fetchCitationDetails();
        setWebsiteData(null);
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }

    handleClose();
  };

  const handleCitationdStyle = (e) => {
    let value = e.target.value;
    console.log("handleCitationdStyle", e, value);
    setCitationStyle(value);
  };

  const fetchCitationDetails = async () => {
    try {
      const email = sessionStorage.getItem("currentUserEmail");
      let data = { email };
      const response = await citationService.getCitationDetails(data);
      if (response.status === 200) {
        const reversedCitations = response.citationDetails.reverse();
        setCitations(reversedCitations);
      } else {
        console.error("Error fetching citation details:", response.message);
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  };

  useEffect(() => {
    fetchCitationDetails();
  }, []);

  const handleAddMember = () => {
    setContributors((prevContributors) => [
      ...prevContributors,
      {
        id: uuidv4(),
        position: "",
        firstName: "",
        middleName: "",
        lastName: "",
        suffix: "",
      },
    ]);
  };

  const handleContributorChange = (id, field, value) => {
    setContributors((prevContributors) =>
      prevContributors.map((contributor) =>
        contributor.id === id ? { ...contributor, [field]: value } : contributor
      )
    );
  };

  const handleDeleteMember = (id) => {
    setContributors((prevContributors) =>
      prevContributors.filter((contributor) => contributor.id !== id)
    );
  };

  const handleSaveCitations = async () => {
    if (
      publicationDayError === "Invalid day" ||
      accessDayError === "Invalid day"
    ) {
      toast.error("Invalid date. Please provide correct date");
      return;
    }

    const email = sessionStorage.getItem("currentUserEmail");
    // Include contributors data in the formData state
    const updatedFormData = {
      ...formData,
      email: email,
      contributors: contributors,
    };

    if (updatedFormData.title === "") {
      toast.error("Please provide citation title.");
      return;
    }

    // Handle save logic here using updatedFormData
    try {
      let sourceType = "";
      if (selectedHeading === "Webpage") {
        sourceType = 0;
      } else if (selectedHeading === "Journal Article") {
        sourceType = 1;
      } else if (selectedHeading === "Book") {
        sourceType = 2;
      } else {
        sourceType = selectedHeading;
      }
      const response = await citationService.getAddCitation(
        updatedFormData,
        citationStyle,
        sourceType
      );
      console.log("Backend Response:", response);

      if (response.status == 200) {
        toast.success("Citation saved successfully");
        fetchCitationDetails();

        const data = {
          userId: sessionStorage.getItem("userId"),
          organizationId: sessionStorage.getItem("organizationId"),
          actionType: "addCitation",
        };

        const addLogs = await addUserLogs(data);
        if (addLogs.status !== 200) {
          toast.error(addLogs.message);
        }

        setFormData({
          heading: "",
          title: "",
          description: "",
          websiteName: "",
          contributors: [],
          doi: "",
          journalName: "",
          url: "",
          edition: "",
          publisher: "",
          articleNumber: "",
          volumeNumber: "",
          issueNumber: "",
          page: "",
          libraryDatabase: "",
          ISBN: "",
          ISSN: "",
          publicationDate: {
            year: "",
            month: "",
            day: "",
          },
          accessDate: {
            year: "",
            month: "",
            day: "",
          },
        });
        setContributors([
          {
            id: uuidv4(),
            position: "",
            firstName: "",
            middleName: "",
            lastName: "",
            suffix: "",
          },
        ]);
        setPublicationYearError("");
        setAccessYearError("");
        setPublicationDayError("");
        setAccessDayError("");
        setSelectedHeading("Webpage");
        setComposestate(false);
        setCreateClassstate(true);
        setPublicationDay("");
        setPublicationMonth("");
        setPublicationYear("");
        setAccessDay("");
        setAccessMonth("");
        setAccessYear("");
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  };

  const handleUpdateCitation = async () => {
    if (
      publicationDayError === "Invalid day" ||
      accessDayError === "Invalid day"
    ) {
      toast.error("Invalid date. Please provide correct date");
      return;
    }

    const updatedFormData = {
      ...formData,
      contributors: contributors,
    };

    if (updatedFormData.title === "") {
      toast.error("Please provide citation title.");
      return;
    }
    try {
      // Call the service function to update the citation details
      const response = await citationService.updateCitationDetails(
        citationID,
        updatedFormData
      );

      // Check if the update was successful
      if (response.status === 200) {
        // Show a success toast
        toast.success("Citation details updated successfully");
        const data = {
          userId: sessionStorage.getItem("userId"),
          organizationId: sessionStorage.getItem("organizationId"),
          actionType: "editCitation",
        };

        const addLogs = await addUserLogs(data);
        if (addLogs.status !== 200) {
          toast.error(addLogs.message);
        }
        // Optionally, you can reset the form or perform other actions
        //setFormData(initialFormData); // Assuming you have an initialFormData state

        // Fetch updated citation details
        fetchCitationDetails();

        // Close the edit mode and show the citation list
        setFormData({
          heading: "",
          title: "",
          description: "",
          websiteName: "",
          contributors: [],
          doi: "",
          journalName: "",
          url: "",
          edition: "",
          publisher: "",
          articleNumber: "",
          volumeNumber: "",
          issueNumber: "",
          page: "",
          libraryDatabase: "",
          ISBN: "",
          ISSN: "",
          publicationDate: {
            year: "",
            month: "",
            day: "",
          },
          accessDate: {
            year: "",
            month: "",
            day: "",
          },
        });
        setContributors([
          {
            id: uuidv4(),
            position: "",
            firstName: "",
            middleName: "",
            lastName: "",
            suffix: "",
          },
        ]);
        setSelectedHeading("Webpage");
        setCreateClassstate(true);
        setComposestate(false);
        setCheckEdit(false);
        setPublicationYearError("");
        setAccessYearError("");
        setPublicationDayError("");
        setAccessDayError("");
        setPublicationDay("");
        setPublicationMonth("");
        setPublicationYear("");
        setAccessDay("");
        setAccessMonth("");
        setAccessYear("");
      } else {
        // Show an error toast if the update fails
        toast.error("Failed to update citation details");
      }
    } catch (error) {
      // Handle errors, e.g., log to console or show an error toast
      console.error("Error updating citation details:", error.message);
      toast.error("Internal server error. Please try again.");
    }
  };

  const backeventhanndlrC = () => {
    setSelectedHeading("Webpage");
    setComposestate(false);
    setCreateClassstate(true);
    setCreatecitation(false);
    setFormData({
      heading: "",
      title: "",
      description: "",
      websiteName: "",
      contributors: [],
      doi: "",
      journalName: "",
      url: "",
      edition: "",
      publisher: "",
      articleNumber: "",
      volumeNumber: "",
      issueNumber: "",
      page: "",
      libraryDatabase: "",
      ISBN: "",
      ISSN: "",
      publicationDate: {
        year: "",
        month: "",
        day: "",
      },
      accessDate: {
        year: "",
        month: "",
        day: "",
      },
    });
    setContributors([
      {
        id: uuidv4(),
        position: "",
        firstName: "",
        middleName: "",
        lastName: "",
        suffix: "",
      },
    ]);
    setPublicationYearError("");
    setAccessYearError("");
    setPublicationDayError("");
    setAccessDayError("");
    setPublicationDay("");
    setPublicationMonth("");
    setPublicationYear("");
    setAccessDay("");
    setAccessMonth("");
    setAccessYear("");
  };

  const backButton = () => {
    setCreateClassstate(false);
    setCreateCitationState(true);
    setSelectedHeading("Webpage");
    setPublicationYearError("");
    setAccessYearError("");
    setPublicationDayError("");
    setAccessDayError("");
    setPublicationDay("");
    setPublicationMonth("");
    setPublicationYear("");
    setAccessDay("");
    setAccessMonth("");
    setAccessYear("");
  };

  console.log(websiteData, "websiteData");

  return (
    <>
      <Loader loading={loading} />

      <div
        style={{
          ...modernStyles.container,
          backgroundColor: isDarkMode ? "#1a1a1a" : "#fff",
          color: isDarkMode ? "#e5e7eb" : "#111",
        }}
      >
        {/* Initial Citation Style Selection */}
        {createCitationState && (
          <div style={modernStyles.headerSection}>
            <div style={{ maxWidth: "400px", margin: "0 auto" }}>
              <label
                style={{
                  ...modernStyles.label,
                  color: isDarkMode ? "#9ca3af" : "#6b7280",
                  display: "block",
                  marginBottom: "12px",
                }}
              >
                Citation Style
              </label>
              <select
                value={citationStyle}
                onChange={(e) => handleCitationdStyle(e)}
                style={{
                  ...modernStyles.selectBox,
                  borderColor: isDarkMode ? "#374151" : "#e5e7eb",
                  backgroundColor: isDarkMode ? "#2a2a2a" : "#fff",
                  color: isDarkMode ? "#e5e7eb" : "#111",
                }}
              >
                <option value="">Select Citation Style</option>
                {professionList.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>

            <div style={modernStyles.emptyState}>
              <div
                style={{
                  ...modernStyles.emptyStateIcon,
                  backgroundColor: isDarkMode ? "#374151" : "#f3f4f6",
                  color: isDarkMode ? "#9ca3af" : "#6b7280",
                }}
              >
                <FormatQuoteIcon style={{ fontSize: "40px" }} />
              </div>
              <h3
                style={{
                  marginBottom: "12px",
                  fontSize: "18px",
                  fontWeight: 600,
                }}
              >
                Create Your First Citation
              </h3>
              <p
                style={{
                  color: isDarkMode ? "#9ca3af" : "#6b7280",
                  marginBottom: "24px",
                  fontSize: "14px",
                }}
              >
                Start by selecting a citation style and create your citations
              </p>
              <button
                onClick={handleCreateCitation}
                style={{
                  ...modernStyles.primaryButton,
                  margin: "0 auto",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#5568d3")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#667eea")
                }
              >
                Create Citation
              </button>
            </div>
          </div>
        )}

        {/* Citation Creation Screen */}
        {creatClassState && (
          <div>
            <button
              onClick={backButton}
              style={{
                ...modernStyles.backButton,
                borderColor: isDarkMode ? "#667eea" : "#667eea",
                color: isDarkMode ? "#667eea" : "#667eea",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = isDarkMode
                  ? "#374151"
                  : "#f3f4f6";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
              }}
            >
              <KeyboardBackspaceIcon style={{ fontSize: "20px" }} />
              Back
            </button>

            {/* Search Container */}
            <div
              style={{
                ...modernStyles.searchContainer,
                borderColor: isDarkMode ? "#374151" : "#e5e7eb",
                backgroundColor: isDarkMode ? "#2a2a2a" : "#f9fafb",
              }}
            >
              {/* Citation Source Selector */}
              <div style={{ ...modernStyles.inputGroup, flex: "0 0 35%" }}>
                <label
                  style={{
                    ...modernStyles.label,
                    color: isDarkMode ? "#9ca3af" : "#6b7280",
                  }}
                >
                  Citation Source
                </label>
                <select
                  value={sourceitem}
                  onChange={(e) => handleSource(e.target.value)}
                  style={{
                    ...modernStyles.input,
                    borderColor: isDarkMode ? "#374151" : "#e5e7eb",
                    backgroundColor: isDarkMode ? "#1a1a1a" : "#fff",
                    color: isDarkMode ? "#e5e7eb" : "#111",
                  }}
                >
                  {sourceList.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Search Input */}
              <div style={modernStyles.inputGroup}>
                <label
                  style={{
                    ...modernStyles.label,
                    color: isDarkMode ? "#9ca3af" : "#6b7280",
                  }}
                >
                  {sourceitem === "Webpage" ? "Enter URL" : "Enter Title"}
                </label>
                <input
                  type="text"
                  value={searchInput}
                  onChange={(e) => {
                    setSearchInput(e.target.value);
                    if (!e.target.value.trim()) {
                      handleCloseAccordion();
                    }
                  }}
                  placeholder={
                    sourceitem === "Webpage"
                      ? "https://example.com"
                      : "Enter citation title"
                  }
                  style={{
                    ...modernStyles.input,
                    borderColor: isDarkMode ? "#374151" : "#e5e7eb",
                    backgroundColor: isDarkMode ? "#1a1a1a" : "#fff",
                    color: isDarkMode ? "#e5e7eb" : "#111",
                  }}
                />
              </div>

              {/* Cite Button */}
                <button
                  onClick={handleCiteButtonClick}
                  style={modernStyles.citeButton}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#2563eb")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "#3b82f6")
                  }
                >
                  Cite
                </button>
            </div>

            {/* Website Data Accordion */}
            {websiteData && (
              <div
                style={{
                  ...modernStyles.accordion,
                  borderColor: isDarkMode ? "#374151" : "#e5e7eb",
                  backgroundColor: isDarkMode ? "#2a2a2a" : "#fff",
                }}
              >
                <div
                  style={{
                    ...modernStyles.accordionHeader,
                    backgroundColor: isDarkMode ? "#374151" : "#f9fafb",
                  }}
                >
                  <div>
                    <h4
                      style={{ margin: 0, fontSize: "16px", fontWeight: 600 }}
                    >
                      {websiteData[0].title}
                    </h4>
                    <p
                      style={{
                        margin: "4px 0 0 0",
                        fontSize: "13px",
                        color: isDarkMode ? "#9ca3af" : "#6b7280",
                      }}
                    >
                      {websiteData[0].sourceType} |{" "}
                      {websiteData[0].publicationDate.year}
                    </p>
                  </div>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <CustomTooltip title="Save Citation">
                      <button
                        onClick={handleSaveCitations2}
                        style={{
                          ...modernStyles.iconButton,
                          backgroundColor: isDarkMode ? "#065f46" : "#d1fae5",
                          color: "#10b981",
                        }}
                      >
                        <AssignmentTurnedInIcon style={{ fontSize: "20px" }} />
                      </button>
                    </CustomTooltip>

                    <CopyToClipboard
                      text={`${websiteData[0].title} - ${
                        websiteData[0].sourceType === "Journal Article"
                          ? websiteData[0].journalName
                          : websiteData[0].sourceType === "Webpage"
                          ? websiteData[0].description
                          : ""
                      } \n ${
                        websiteData[0].sourceType === "Book"
                          ? `Edition - ${websiteData[0].edition}\n`
                          : ""
                      } ${
                        websiteData[0].sourceType === "Book"
                          ? `Publisher: ${websiteData[0].publisher} \n`
                          : ""
                      } ${websiteData[0].sourceType} | ${
                        websiteData[0].publicationDate.year
                      }\n ${
                        websiteData[0].sourceType === "Book" ||
                        (websiteData[0].sourceType === "Journal Article" &&
                          websiteData[0].doi !== "")
                          ? `DOI - ${websiteData[0].doi} \n`
                          : ""
                      }${websiteData[0].url}`}
                      onCopy={handleCopyClick}
                    >
                      <CustomTooltip title="Copy">
                        <button
                          style={{
                            ...modernStyles.iconButton,
                            backgroundColor: isDarkMode ? "#1e3a8a" : "#dbeafe",
                            color: "#3b82f6",
                          }}
                        >
                          <ContentCopyIcon style={{ fontSize: "20px" }} />
                        </button>
                      </CustomTooltip>
                    </CopyToClipboard>

                    <CustomTooltip title="Close">
                      <button
                        onClick={handleCloseAccordion}
                        style={{
                          ...modernStyles.iconButton,
                          backgroundColor: isDarkMode ? "#7f1d1d" : "#fee2e2",
                          color: "#ef4444",
                        }}
                      >
                        <CloseIcon style={{ fontSize: "20px" }} />
                      </button>
                    </CustomTooltip>
                  </div>
                </div>
              </div>
            )}

            {/* Compose Button & Citations List */}
            <div style={{ marginTop: "40px", textAlign: "center" }}>
              <button
                onClick={handleCompose}
                style={{
                  ...modernStyles.primaryButton,
                  backgroundColor: "transparent",
                  color: "#667eea",
                  border: "2px solid #667eea",
                  marginBottom: "12px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = isDarkMode
                    ? "#374151"
                    : "#f3f4f6";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                }}
              >
                + Compose Citation
              </button>
              <p
                style={{
                  fontSize: "13px",
                  color: isDarkMode ? "#9ca3af" : "#6b7280",
                  maxWidth: "400px",
                  margin: "0 auto",
                }}
              >
                Cite a wide range of sources and export them in your favorite
                styles!
              </p>
            </div>

            {/* Citations List */}
            <div style={{ marginTop: "32px" }}>
              {citations.map((citation, index) => (
                <CoAuthor_CitationCard
                  key={index}
                  citation={citation}
                  index={index}
                  fetchCitationDetails={fetchCitationDetails}
                  setComposestate={setComposestate}
                  setCreateClassstate={setCreateClassstate}
                  setFormData={setFormData}
                  setCheckEdit={setCheckEdit}
                  setContributors={setContributors}
                  setCitationID={setCitationID}
                  setSelectedHeading={setSelectedHeading}
                />
              ))}
            </div>
          </div>
        )}

        {/* Compose Form */}
        {composeState && (
          <div>
            <button
              onClick={backeventhanndlrC}
              style={{
                ...modernStyles.backButton,
                borderColor: isDarkMode ? "#667eea" : "#667eea",
                color: isDarkMode ? "#667eea" : "#667eea",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = isDarkMode
                  ? "#374151"
                  : "#f3f4f6";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
              }}
            >
              <KeyboardBackspaceIcon style={{ fontSize: "20px" }} />
              Back
            </button>

            {/* Heading Selector */}
            <div style={{ textAlign: "center", marginBottom: "24px" }}>
              {checkEdit ? (
                <h3 style={{ fontSize: "20px", fontWeight: 600 }}>
                  {formData.heading}
                </h3>
              ) : (
                <Dropdown>
                  <Dropdown.Toggle
                    variant="outline-primary"
                    style={{
                      padding: "10px 24px",
                      borderRadius: "10px",
                      fontSize: "14px",
                      fontWeight: 600,
                    }}
                  >
                    {formData.heading || selectedHeading}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {headings.map((item) => (
                      <Dropdown.Item
                        key={item}
                        onClick={() => {
                          setSelectedHeading(item);
                          handleInputChange("heading", item);
                        }}
                      >
                        {item}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>

            {/* Form Fields */}
            <Form style={{ maxWidth: "600px", margin: "0 auto" }}>
              {/* Title Field */}
              {(selectedHeading === "Book Chapter" ||
                selectedHeading === "Webpage" ||
                selectedHeading === "Image" ||
                selectedHeading === "Video" ||
                selectedHeading === "Journal Article" ||
                selectedHeading === "Book" ||
                selectedHeading === "Online Dictionary Entry" ||
                selectedHeading === "Online News Article" ||
                selectedHeading === "Report" ||
                selectedHeading === "Website") && (
                <div style={modernStyles.formGroup}>
                  <label
                    style={{
                      ...modernStyles.formLabel,
                      color: isDarkMode ? "#e5e7eb" : "#374151",
                    }}
                  >
                    Title *
                  </label>
                  <input
                    type="text"
                    value={formData.title}
                    onChange={(e) => handleInputChange("title", e.target.value)}
                    style={{
                      ...modernStyles.formInput,
                      borderColor: isDarkMode ? "#374151" : "#e5e7eb",
                      backgroundColor: isDarkMode ? "#2a2a2a" : "#fff",
                      color: isDarkMode ? "#e5e7eb" : "#111",
                    }}
                    placeholder="Enter title"
                  />
                </div>
              )}

              {/* Add all other form fields following the same pattern */}
              {/* Journal Name, Description, Website Name, etc. */}
              {/* Keep the same logic but apply modern styling */}

              {/* Contributors Accordion */}
              {(selectedHeading === "Webpage" ||
                selectedHeading === "Image" ||
                selectedHeading === "Video" ||
                selectedHeading === "Journal Article" ||
                selectedHeading === "Book" ||
                selectedHeading === "Book Chapter" ||
                selectedHeading === "Online Dictionary Entry" ||
                selectedHeading === "Online News Article" ||
                selectedHeading === "Report") && (
                <Accordion style={{ marginBottom: "20px" }}>
                  <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography style={{ fontWeight: 600 }}>
                      Contributors
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails style={{ flexDirection: "column" }}>
                    {contributors.map((contributor, index) => (
                      <div
                        key={index}
                        style={{
                          ...modernStyles.contributorCard,
                          borderColor: isDarkMode ? "#374151" : "#e5e7eb",
                          backgroundColor: isDarkMode ? "#2a2a2a" : "#f9fafb",
                        }}
                      >
                        <ContributorForm
                          contributor={contributor}
                          handleDelete={() =>
                            handleDeleteMember(contributor.id)
                          }
                          handleInputChange={(field, value) =>
                            handleContributorChange(
                              contributor.id,
                              field,
                              value
                            )
                          }
                          isDarkMode={isDarkMode}
                        />
                      </div>
                    ))}
                    <button
                      onClick={handleAddMember}
                      style={{
                        ...modernStyles.primaryButton,
                        backgroundColor: "transparent",
                        color: "#667eea",
                        border: "2px dashed #667eea",
                        width: "100%",
                      }}
                    >
                      + Add Member
                    </button>
                  </AccordionDetails>
                </Accordion>
              )}

              {/* Save/Update Button */}
              <div
                style={{
                  textAlign: "center",
                  marginTop: "32px",
                  marginBottom: "32px",
                }}
              >
                <button
                  onClick={
                    checkEdit ? handleUpdateCitation : handleSaveCitations
                  }
                  style={modernStyles.primaryButton}
                  onMouseEnter={(e) =>
                    (e.target.style.backgroundColor = "#5568d3")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.backgroundColor = "#667eea")
                  }
                >
                  {checkEdit ? "Update Citation" : "Save Citation"}
                </button>
              </div>
            </Form>
          </div>
        )}
      </div>
    </>
  );
};

// Updated ContributorForm component with modern styling
const ContributorForm = ({
  contributor,
  handleDelete,
  handleInputChange,
  isDarkMode,
}) => {
  return (
    <div>
      <div style={modernStyles.contributorGrid}>
        <div style={modernStyles.formGroup}>
          <label
            style={{
              ...modernStyles.formLabel,
              color: isDarkMode ? "#e5e7eb" : "#374151",
            }}
          >
            Position
          </label>
          <input
            type="text"
            value={contributor.position}
            onChange={(e) => handleInputChange("position", e.target.value)}
            style={{
              ...modernStyles.formInput,
              borderColor: isDarkMode ? "#374151" : "#e5e7eb",
              backgroundColor: isDarkMode ? "#1a1a1a" : "#fff",
              color: isDarkMode ? "#e5e7eb" : "#111",
            }}
            placeholder="e.g., Author"
          />
        </div>

        <div style={modernStyles.formGroup}>
          <label
            style={{
              ...modernStyles.formLabel,
              color: isDarkMode ? "#e5e7eb" : "#374151",
            }}
          >
            First Name
          </label>
          <input
            type="text"
            value={contributor.firstName}
            onChange={(e) => handleInputChange("firstName", e.target.value)}
            style={{
              ...modernStyles.formInput,
              borderColor: isDarkMode ? "#374151" : "#e5e7eb",
              backgroundColor: isDarkMode ? "#1a1a1a" : "#fff",
              color: isDarkMode ? "#e5e7eb" : "#111",
            }}
          />
        </div>

        <div style={modernStyles.formGroup}>
          <label
            style={{
              ...modernStyles.formLabel,
              color: isDarkMode ? "#e5e7eb" : "#374151",
            }}
          >
            Middle Name
          </label>
          <input
            type="text"
            value={contributor.middleName}
            onChange={(e) => handleInputChange("middleName", e.target.value)}
            style={{
              ...modernStyles.formInput,
              borderColor: isDarkMode ? "#374151" : "#e5e7eb",
              backgroundColor: isDarkMode ? "#1a1a1a" : "#fff",
              color: isDarkMode ? "#e5e7eb" : "#111",
            }}
          />
        </div>

        <div style={modernStyles.formGroup}>
          <label
            style={{
              ...modernStyles.formLabel,
              color: isDarkMode ? "#e5e7eb" : "#374151",
            }}
          >
            Last Name
          </label>
          <input
            type="text"
            value={contributor.lastName}
            onChange={(e) => handleInputChange("lastName", e.target.value)}
            style={{
              ...modernStyles.formInput,
              borderColor: isDarkMode ? "#374151" : "#e5e7eb",
              backgroundColor: isDarkMode ? "#1a1a1a" : "#fff",
              color: isDarkMode ? "#e5e7eb" : "#111",
            }}
          />
        </div>

        <div style={modernStyles.formGroup}>
          <label
            style={{
              ...modernStyles.formLabel,
              color: isDarkMode ? "#e5e7eb" : "#374151",
            }}
          >
            Suffix
          </label>
          <input
            type="text"
            value={contributor.suffix}
            onChange={(e) => handleInputChange("suffix", e.target.value)}
            style={{
              ...modernStyles.formInput,
              borderColor: isDarkMode ? "#374151" : "#e5e7eb",
              backgroundColor: isDarkMode ? "#1a1a1a" : "#fff",
              color: isDarkMode ? "#e5e7eb" : "#111",
            }}
            placeholder="e.g., Jr., Sr."
          />
        </div>
      </div>

      <button
        onClick={handleDelete}
        style={{
          marginTop: "12px",
          padding: "8px 16px",
          backgroundColor: isDarkMode ? "#7f1d1d" : "#fee2e2",
          color: "#ef4444",
          border: "none",
          borderRadius: "8px",
          fontSize: "13px",
          fontWeight: 600,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <Delete style={{ fontSize: "16px" }} />
        Remove Contributor
      </button>
    </div>
  );
};
